<template>
  <div class="" testek="product-detail">
    <div class="header"></div>
    <BaseDetail
      @viewDetail="viewDetail"
      @addData="addData"
      @addMoreData="addMoreData"
      :currentItem="currentItem"
      :titleDetail="$t('i18nCommon.TitleUserId')"
    >
      <template #header>
        <div class="font-bold text-xl mb-4">{{ title }}</div>
      </template>
      <template #content>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <a-form-item
                prop="Id"
                testek="Id"
                class="columns-1 w-full"
                v-if="mode == $enum.Mode.Edit"
              >
                <div class="flex">
                  <div class="font-bold min-w-32">
                    ID
                    <span class="ml-1 text-red-700">*</span>
                  </div>
                  <a-input v-model:value="ruleForm.userId" />
                </div>
              </a-form-item>
              <div class="flex columns-2">
                <a-form-item prop="fullName" testek="fullName" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Name") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.fullName" />
                  </div>
                </a-form-item>
                <a-form-item class="w-full" prop="userCode" testek="userCode">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Code") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.userCode" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="phoneNumber" testek="phoneNumber" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.phoneNumber" />
                  </div>
                </a-form-item>
                <a-form-item prop="email" testek="email" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      Email
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.email" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item
                  prop="identityNumber"
                  testek="identityNumber"
                  class="w-full mr-8"
                >
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nCommon.UserInfo.IdentityNumber") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.identityNumber" />
                  </div>
                </a-form-item>
                <a-form-item prop="note" testek="note" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Note") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.note" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="syncCode" testek="syncCode" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.SyncCode") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.syncCode" />
                  </div>
                </a-form-item>
                <a-form-item prop="workPhone" testek="workPhone" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.WorkPhone") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.workPhone" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="username" testek="username" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.UserName") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.username" />
                  </div>
                </a-form-item>
                <a-form-item prop="password" testek="password" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Password") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.password" />
                  </div>
                </a-form-item>
              </div>
              <a-form-item class="mt-6">
                <div class="flex">
                  <a-button
                    type="primary"
                    testek="btn-add"
                    @click="submitForm()"
                    class="mr-4"
                  >
                    {{ $t("i18nCommon.Add") }}
                  </a-button>
                  <a-button type="primary" testek="btn-add-more" @click="addMoreData()">
                    {{ $t("i18nCommon.AddMore") }}
                  </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </template>
    </BaseDetail>
    <div v-if="isShow && user">
      <a-modal v-model:open="isShow" :closable="false" centered :width="800">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.User") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form ref="ruleFormRef" :rules="rules" class="demo-ruleForm" status-icon>
              <div class="flex columns-2">
                <a-form-item prop="fullName" testek="fullName" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Name") }}
                    </div>
                    <a-input v-model:value="user.fullName" />
                  </div>
                </a-form-item>
                <a-form-item class="w-full" prop="userCode" testek="userCode">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Code") }}
                    </div>
                    <a-input v-model:value="user.userCode" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="phoneNumber" testek="phoneNumber" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                    </div>
                    <a-input v-model:value="user.phoneNumber" />
                  </div>
                </a-form-item>
                <a-form-item prop="email" testek="email" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">Email</div>
                    <a-input v-model:value="user.email" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item
                  prop="identityNumber"
                  testek="identityNumber"
                  class="w-full mr-8"
                >
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nCommon.UserInfo.IdentityNumber") }}
                    </div>
                    <a-input v-model:value="user.identityNumber" />
                  </div>
                </a-form-item>
                <a-form-item prop="note" testek="note" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Note") }}
                    </div>
                    <a-input v-model:value="user.note" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="syncCode" testek="syncCode" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.SyncCode") }}
                    </div>
                    <a-input v-model:value="user.syncCode" />
                  </div>
                </a-form-item>
                <a-form-item prop="workPhone" testek="workPhone" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.WorkPhone") }}
                    </div>
                    <a-input v-model:value="user.workPhone" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="username" testek="username" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.UserName") }}
                    </div>
                    <a-input v-model:value="user.username" />
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { ModuleUser } from "@/store/module-const";
import BaseDetail from "@/views/base/BaseDetail.vue";
import { mapActions } from "vuex";
import _ from "lodash";
export default {
  name: "UserDetail",
  components: {
    BaseDetail,
  },
  props: {},
  computed: {
    title() {
      if (this.mode == this.$enum.Mode.Edit) return this.$t("i18nCommon.EditUser");
      return this.$t("i18nCommon.AddUser");
    },
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      suppliers: [],
      categories: [],
      statuses: [],
      currentItem: {},
      user: {},
      isShow: false,
      mode: this.$enum.Mode.Add,
    };
  },
  created() {
    const me = this;
    me.initDataStatic();
    me.$emitter.on("LoadEditUser", me.loadDataEdit);
  },
  beforeDestroy() {
    const me = this;
    me.$emitter.off("LoadEditUser", me.loadDataEdit);
  },
  methods: {
    ...mapActions(ModuleUser, ["createUser", "getUser", "updateUser"]),
    initDataStatic() {
      const me = this;
      me.rules = {
        email: [
          {
            required: true,
            message: `${me.$t("i18nProduct.EmailInvalid")}`,
            trigger: "blur",
          },
        ],
        fullName: [
          {
            required: true,
            message: `${me.$t("i18nProduct.NameInvalid")}`,
            trigger: "blur",
          },
        ],
        phoneNumber: [
          {
            required: true,
            message: `${me.$t("i18nProduct.PhoneInvalid")}`,
            trigger: "blur",
          },
        ],
        userCode: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CodeInvalid")}`,
            trigger: "blur",
          },
        ],
        syncCode: [
          {
            required: true,
            message: `${me.$t("i18nProduct.SyncCodeInvalid")}`,
            trigger: "blur",
          },
        ],
        note: [
          {
            required: true,
            message: `${me.$t("i18nProduct.NoteInvalid")}`,
            trigger: "blur",
          },
        ],
        identityNumber: [
          {
            required: true,
            message: `${me.$t("i18nProduct.IdentityNumberInvalid")}`,
            trigger: "blur",
          },
        ],
        workPhone: [
          {
            required: true,
            message: `${me.$t("i18nProduct.WorkPhoneInvalid")}`,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: `${me.$t("i18nProduct.PasswordInvalid")}`,
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: `${me.$t("i18nProduct.UserNameInvalid")}`,
            trigger: "blur",
          },
        ],
      };
    },
    loadDataEdit: _.debounce(async function (payload) {
      const me = this;
      if (!payload) return;
      me.mode = payload.mode;
      setTimeout(async () => {
        let user = await me.getUser({ id: payload.id });
        if (user) {
          me.ruleForm = {
            userId: user.userId,
            email: user.email,
            fullName: user.fullName,
            phoneNumber: user.phoneNumber,
            userCode: user.userCode,
            userStatus: user.userStatus,
            deleted: user.deleted,
            expiredAt: user.expiredAt,
            identityNumber: user.identityNumber,
            note: user.note,
            syncCode: user.syncCode,
            userAccount: user.userAccount,
            username: user.userAccount.username,
            password: user.userAccount.password,
            userGroups: user.userGroups,
            workPhone: user.workPhone,
          };
        }
      }, 300);
    }, 300),
    async submitForm(isReset = true) {
      const me = this;
      let formEl = me.$refs.ruleFormRef;
      if (!formEl) return;
      formEl
        .validate()
        .then(async () => {
          if (me.mode == me.$enum.Mode.Edit) {
            await me.editData();
          } else {
            await me.addData(isReset);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onChangeStatus(payload) {
      const me = this;
      let status = me.statuses.find((x) => x.id == payload);
      if (status) {
        me.ruleForm.status = status.id;
      }
    },

    addMoreData: _.debounce(async function () {
      const me = this;
      await me.submitForm(false);
    }, 300),
    addData: _.debounce(async function (isReset = true) {
      const me = this;
      let payload = {
        ...me.ruleForm,
        availableAt: new Date().getTime(),
        userStatus: "ACTIVE",
        deleted: false,
        userAccount: {
          accStatus: "ACTIVE",
          password: me.ruleForm.password,
          username: me.ruleForm.username,
        },
        userGroups: [],
      };

      let result = await me.createUser(payload);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(me.$t("i18nCommon.AddUserSuccess"));
        if (isReset == true) {
          me.ruleForm = {};
        }
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddUserFail"),
          "warning"
        );
      }
    }, 300),

    editData: _.debounce(async function () {
      const me = this;

      me.ruleForm.userAccount = {
        accStatus: "ACTIVE",
        password: me.ruleForm.password,
        username: me.ruleForm.username,
      };
      let result = await me.updateUser(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditUserSuccess")
        );
        me.ruleForm = {};
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditUserFail"),
          "warning"
        );
      }
    }, 300),

    viewDetail: _.debounce(async function (params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.user = await me.getUser({ id: params.id });
      if (me.user) {
        me.isShow = true;
      } else {
      }
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
